import React from 'react';

const MyBookings = () => {
    return (
        <div>
            buyers Bookings
        </div>
    );
};

export default MyBookings;